export default "__VITE_ASSET__ClrMdqmb__"